export const environment = {
    production: false,
    appVersion: require('../../package.json').version + '-demo',
    appTitle: "CRM BestLevelSupport by MVIP",
    appLogoPath : "assets\\Wortmarkekomplett.svg",
    appFavicon : "assets\\faviconente.ico",
    appLogoFavicon : "assets\\favicondemo.ico",
    appFavicongif :"assets\\favicon1.gif",
    pCC_loginissue_Frontend: "https://help.mvip.simply-supported.de",
    tCCTicketFrontend: "https://support.mvip.simply-supported.de",
    tCCTicketServer: "https://ticket.mvip.simply-supported.de",
    TicketAuthorisation: "https://authorisation.mvip.simply-supported.de"

};
